<div class="custom-scrollbar-css">
  <ngx-spinner *ngIf="spinnerActiveEdit != false" bdColor="rgba(100,112,124,0.56)" size="medium"
               color="#233547" type="ball-clip-rotate-multiple" [fullScreen]="true">
    <p style="color: white"></p>
  </ngx-spinner>
  <h2 class="modal-title" style="margin-top: 3%; margin-left: 65px; font-weight: bold;">
    Édition d'un véhicule : &nbsp; <strong> {{nameTitle}} </strong> &nbsp; ID - <strong> {{entry}} </strong></h2>
  <hr style="
    border: 1px solid #262756;
    opacity: 0.23;
    width: 85%;
  "/>
  <div class="container-fluid mt-3">
    <form class="mt-4" [formGroup]="registerForm" (submit)="submitForm()">
      <div class="row" style="margin-left: 2%;">
        <div class="col-5 col-md-5 w-100">
          <h1 class="p-2">
            Hiérarchie</h1>
          <mat-form-field appearance="fill" class="w-100 mb-3 disable">
            <mat-label>Revendeur</mat-label>
            <mat-select [(ngModel)]="reseller_id" formControlName="reseller_id" class="inputModal"
                        [errorStateMatcher]="matcher" required>
              <mat-option (click)="getIdrevendeur(revendeurs.id)" *ngFor="let revendeurs of revendeurs"
                          [value]="revendeurs.id">
                {{revendeurs.name}}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="registerForm.controls['reseller_id'].invalid"
                       class="elhoo_compte_messageErrorPositionModal">
              Revendeur is <strong>required</strong>
            </mat-error>
          </mat-form-field>
          <mat-form-field appearance="fill" class="disable"> {{company}}
            <input matInput name="item_id"
                   [(value)]="companyname"
                   formControlName="company_id" >

          </mat-form-field>

        </div>
        <div class="col-1 col-md-1 w-100"></div>
        <div class="col-5 col-md-5 w-100" style="margin-left: 5%">
          <h1 class="p-2">
            Configuration</h1>
          <mat-form-field appearance="fill" class="w-100 mb-3">
            <mat-label>Type</mat-label>
            <mat-select [(ngModel)]="unit_type" formControlName="unit_type" class="inputModal"
                        [errorStateMatcher]="matcher" required>
              <mat-select-trigger>
                <i class="{{icon}}"></i> &nbsp;{{unit_type}}
              </mat-select-trigger>
              <mat-option (click)="getItemsType(typeVehicules)" *ngFor="let typeVehicules of typeVehicules"
                          [value]="typeVehicules.name">
                <i class="{{typeVehicules.icon}}"></i> {{typeVehicules.name}}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="registerForm.controls['unit_type'].invalid"
                       class="elhoo_compte_messageErrorPositionModal">
              Type is <strong>required</strong>
            </mat-error>
          </mat-form-field>
          <!-- <mat-form-field appearance="fill" class="w-100 mb-3">
            <mat-label>Conducteur</mat-label>
            <mat-select [(ngModel)]="driver" formControlName="driver" class="inputModal"
            >
              <mat-option *ngFor="let conducteurCompany of conducteurCompany" [value]="conducteurCompany.name">
                {{conducteurCompany.name}}
              </mat-option>
            </mat-select>
          </mat-form-field> -->
        </div>
      </div>
      <div class="row">
        <div class="col-5 col-md-5 w-100" style="margin-left: 3%; margin-top: 3%;">
          <h1 class="p-2">
            Administration</h1>
          <div class="row">
            <div class="col-6 col-md-12 w-100">
              <div class="row d-none">
                <div class="col-6 col-md-6 w-100">
                  <mat-form-field appearance="fill" class="w-100 mb-3">
                    <mat-label>Groupe</mat-label>
                    <mat-select [disabled]="true">
                      <mat-option *ngFor="let groupe of groupe" [value]="groupe">
                        {{groupe}}
                      </mat-option>
                    </mat-select>
                    <mat-hint>ce champ désactivé!</mat-hint>
                  </mat-form-field>
                </div>
                <div class="col-6 col-md-6 w-100">
                  <div class="row">
                    <div class="col-6 col-md-12 w-100">
                      <mat-form-field appearance="fill" class="example-full-width" class="w-100 mb-3">
                        <mat-label>Nom groupe</mat-label>
                        <input disabled autocomplete="off" matInput #input id="name" name="name">
                        <button (click)="addUser()" mat-button matSuffix mat-icon-button>
                          <mat-icon><img src="https://img.icons8.com/color/22/000000/group-foreground-selected.png"/>
                          </mat-icon>
                        </button>
                        <mat-hint>ce champ désactivé!</mat-hint>
                      </mat-form-field>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-6 col-md-12 w-100">
              <div class="row">
                <div class="col-6 col-md-12 w-100">
                  <mat-form-field appearance="fill" class="example-full-width" class="w-100 mb-3">
                    <mat-label>Nom</mat-label>
                    <input [(ngModel)]="name" autocomplete="off" matInput #input formControlName="name"
                           class="inputModal" [errorStateMatcher]="matcher" required>
                    <mat-error *ngIf="registerForm.controls['name'].invalid"
                               class="elhoo_compte_messageErrorPositionModal">
                      Nom is <strong>required</strong>
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
              <mat-form-field appearance="fill" class="example-full-width" class="w-100 mb-3">
                <mat-label>Plaque</mat-label>
                <input autocomplete="off" [(ngModel)]="plate" matInput formControlName="plate" class="inputModal">
              </mat-form-field>
              <mat-form-field appearance="fill" class="example-full-width" class="w-100 mb-3">
                <mat-label>Marque</mat-label>
                <input [(ngModel)]="brand" matInput formControlName="brand" class="inputModal"
                >
              </mat-form-field>
              <div class="row">
                <div class="col-6 col-md-12 w-100">
                  <mat-form-field appearance="fill" class="w-100 mb-3 d-none">
                    <mat-label>Date de mise en circulation</mat-label>
                    <input matInput [matDatepicker]="dp" [formControl]="date">
                    <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
                    <mat-datepicker #dp startView="multi-year" (yearSelected)="chosenYearHandler($event)"
                                    (monthSelected)="chosenMonthHandler($event, dp)" panelClass="example-month-picker">
                    </mat-datepicker>
                  </mat-form-field>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-1 col-md-1 w-100"></div>
        <div class="col-5 col-md-5 w-100" style="margin-left: 3%; margin-top: 3%;">
          <h1 class="p-2">
            Informations sur le boîtier</h1>
          <mat-form-field appearance="fill" class="example-full-width" class="w-100 mb-3">
            <mat-label>ID boîtier</mat-label>
            <input maxlength="25" [(ngModel)]="device_id" matInput type="number" formControlName="device_id"
                   class="inputModal"
                   [errorStateMatcher]="matcher" required>
            <mat-error *ngIf="registerForm.controls['device_id'].invalid"
                       class="elhoo_compte_messageErrorPositionModal">
              ID boîtier is <strong>required</strong>
            </mat-error>
          </mat-form-field>
          <mat-form-field appearance="fill" class="example-full-width" class="w-100 mb-3">
            <mat-label>Numéro de SIM</mat-label>
            <input autocomplete="off" minlength="4" maxlength="15" type="tel" [(ngModel)]="boitier_sim" matInput
                   formControlName="boitier_sim" class="inputModal">
            <mat-icon matSuffix>perm_phone_msg</mat-icon>
          </mat-form-field>
        </div>
      </div>
    </form>
  </div>
</div>
<div class=" justify-content-end d-flex" style="margin-right: 5%; margin-bottom: 40px;">
  <!-- <a *ngIf="!registerForm.valid" class="savebtn mr-2" type="submit"   aria-pressed="true"
  [ngClass]="{'disabled': !registerForm.valid }"  >Enregistrer</a> -->
  <a class="savebtn mr-2" type="submit" aria-pressed="true"
     (click)="submitForm()">Enregistrer</a>
  <a class="cancelbtn" type="submit" aria-pressed="true" (click)="onNoClick()">Annuler</a>
</div>
